import { AnalyticsHandler } from '@Foundation/analyticsHandler';

export const careersearch = {
  name: 'career-search',

  bind: (el) => {
    const element = el;

    element.addEventListener('submit', function (e) {
      e.preventDefault();
      var keyword = e.target.querySelector('.search-keyword').value;
      var action = e.target.getAttribute('action');

      AnalyticsHandler.pushDataLayer({
        event: 'uaevent',
        eventCategory: 'internal search',
        eventAction: 'search::career',
        eventLabel: keyword
      });

      window.open(`${action}${keyword}`, '_blank');
    });
  }
};
